import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    DailyTruck,
    DailyTruckResponse,
    DailyTrucksListResponse,
    createDailyTruck,
    updateDailyTruck,
    deleteDailyTruck,
    CreateDailyTruckBody,
    UpdateDailyTruckBody,
    UpdateDailyTrucksPriceBatchResponse,
    UpdateDailyTrucksPriceBatchBody,
    updateDailyTrucksPriceBatch,
} from '../../services/apiSLTP/dailyReports/dailyTrucks';

// ---------------- CREATE DailyTruck ----------------
type UseCreateDailyTruckMutationOptions = MutationOptions<DailyTruckResponse, Error, { body: CreateDailyTruckBody }>;

export const useCreateDailyTruckMutation = (options?: UseCreateDailyTruckMutationOptions) => {
    const createDailyTruckMutation: MutationFunction<DailyTruckResponse, { body: CreateDailyTruckBody }> = async ({ body }) => {
        try {
            const response: DailyTruckResponse = await createDailyTruck(body);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during create daily truck');
        }
    };

    return useMutation(createDailyTruckMutation, options);
};

// ---------------- UPDATE DailyTruck ----------------
type UseUpdateDailyTruckMutationOptions = MutationOptions<DailyTruckResponse, Error, { id: string; body: UpdateDailyTruckBody }>;

export const useUpdateDailyTruckMutation = (options?: UseUpdateDailyTruckMutationOptions) => {
    const updateDailyTruckMutation: MutationFunction<DailyTruckResponse, { id: string; body: UpdateDailyTruckBody }> = async ({ id, body }) => {
        try {
            const response: DailyTruckResponse = await updateDailyTruck(id, body);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during update daily truck');
        }
    };

    return useMutation(updateDailyTruckMutation, options);
};

type UseUpdateDailyTrucksPriceBatchMutationOptions = MutationOptions<
    UpdateDailyTrucksPriceBatchResponse,
    Error,
    { body: UpdateDailyTrucksPriceBatchBody }
>;

export const useUpdateDailyTrucksPriceBatchMutation = (options?: UseUpdateDailyTrucksPriceBatchMutationOptions) => {
    const updateDailyTrucksPriceBatchMutation: MutationFunction<
        UpdateDailyTrucksPriceBatchResponse,
        { body: UpdateDailyTrucksPriceBatchBody }
    > = async ({ body }) => {
        try {
            const response: UpdateDailyTrucksPriceBatchResponse = await updateDailyTrucksPriceBatch(body);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during batch price update');
        }
    };

    return useMutation(updateDailyTrucksPriceBatchMutation, options);
};

// ---------------- DELETE DailyTruck ----------------
type UseDeleteDailyTruckMutationOptions = MutationOptions<DailyTruckResponse, Error, { id: string }>;

export const useDeleteDailyTruckMutation = (options?: UseDeleteDailyTruckMutationOptions) => {
    const deleteDailyTruckMutation: MutationFunction<DailyTruckResponse, { id: string }> = async ({ id }) => {
        try {
            const response: DailyTruckResponse = await deleteDailyTruck(id);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during delete daily truck');
        }
    };

    return useMutation(deleteDailyTruckMutation, options);
};
